<template>
  <div class="bategory container1">
    <!-- 品牌 -->
    <div class="brand">
      <div class="left">
        <div class="logo">
          <div class="img" v-for="(v,i) in logoFilePathList" :key="i">
            <img v-lazy="v" alt="">
          </div>
          <div class="name">
            <div class="title">{{brandInfo.name}}</div>
            <div class="sale">在售商品：{{brandInfo.goodsCount}}件</div>
          </div>
        </div>
        <div class="content">{{brandInfo.introduction}}</div>
        <div class="dwonload">
          <a class="item" :href="v.eleFilePath" target="_blank" v-for="(v,i) in seriesList" :key="i">{{v.name}}图册</a>
        </div>
      </div>
      <div class="right" v-for="(v,i) in publicizeFilePathList" :key="i">
        <img v-lazy="v" alt="">
      </div>
    </div>
    <!-- 已选 -->
    <dl class="selected cate_item" v-if="selectList.length > 0 || $route.query.searchKey">
      <dt class="label">您已选择</dt>
      <dd class="content">
        <div class="td-list">
          <span v-for="(item, index) in selectList" :key="index" class="td_item" @click="cancelSelect(item)">
            <span class="key_name">{{item.key?item.key+'：':""}}</span>
            <span>{{ item.value }}</span>
            <i class="myi el-icon-close"></i>
          </span>
          <!-- 关键词 -->
          <span class="td_item keyw" v-if="$route.query.searchKey">
            <span>{{`"${$route.query.searchKey}"`}}</span>
          </span>
          <span class="clear td_item com_link" v-if="selectList.length > 0 || !$route.query.searchKey" @click="clearSelect">清空选择</span>
        </div>
      </dd>
    </dl>
    <!-- 分类 -->
    <dl class="classify cate_item" :class="{'show':cateMore}">
      <dt class="label">分类</dt>
      <dd class="content" ref="cateContentRef">
        <div class="td-list">
          <span class="td_item com_link" :class="{active:!query.categorySerNo}" @click="sureCategory(undefined)">全部</span>
          <span :ref="'cateItem'+index" class="td_item com_link" :class="{active:query.categorySerNo == item.serNo}" v-for="(item, index) in categoryList" :key="index" @click="sureCategory(item.serNo)">
            {{ item.name }}
          </span>
        </div>
        <div class="td-more" v-if="cateContentHeight>48">
          <span class="com_link" @click="cateMore = !cateMore">
            <span>{{cateMore?"收起":'更多'}}</span>
            <i :class="cateMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </span>
        </div>
      </dd>
    </dl>
    <!-- 属性 -->
    <dl class="attr cate_item" :class="{'show':item.attrMore,'border2':item.attrMulti}" v-for="(item, index) in showProplist" :key="index">
      <dt class="label">{{ item.name }}</dt>
      <dd class="content" :ref="'attrContentRef'+index">
        <div class="td-list">
          <span v-for="(v, i) in item.fieldList" :key="i" class="td_item com_link" :class="{ active: v.checked }" @click="chooseItem(v,item.attrMulti)">
            {{ v.value }}
          </span>
          <div class="mutl-btn" v-if="item.attrMulti">
            <el-button class="btn" type="info" @click="confirmMulti(item.fieldList)">确定</el-button>
            <el-button class="btn" type="info" @click="cancelMulti(item.fieldList,item)">取消</el-button>
          </div>
        </div>
        <div class="td-more" v-show="!item.attrMulti">
          <span class="com_link" @click="item.attrMore = !item.attrMore" v-if="item.attrContentHeight>48">
            <span>{{item.attrMore?"收起":'更多'}}</span>
            <i :class="item.attrMore? 'el-icon-arrow-up': 'el-icon-arrow-down'"></i>
          </span>
        </div>
        <div class="td-mult" v-show="!item.attrMulti">
          <div class="mult_btn" @click="openMulti(item)">
            <i class="el-icon-plus"></i>
            <span>多选</span>
          </div>
        </div>
      </dd>
    </dl>
    <!-- 表头 -->
    <div class="table_header com_between">
      <div class="table_type">
        <div class="header_left cur_pointer" :class="{active:query.sortType==0}" @click="changeOrder(0)">
          <span>综合<i class="el-icon-bottom"></i></span>
        </div>

        <div class="header_left cur_pointer" :class="{active:query.sortType==4}" @click="changeOrder(4)">
          <span>销量<i class="el-icon-bottom"></i></span>
        </div>

        <div class="header_left cur_pointer" :class="{active:query.sortType==1}" @click="changeOrder(1)">
          <span>新品<i class="el-icon-bottom"></i></span>
        </div>

        <div class="header_left">
          <span class="price_box">价格
            <i class="el-icon-caret-top top_fz cur_pointer" :class="{active:query.sortType==3}" @click="changeOrder(3)"></i>
            <i class="el-icon-caret-bottom bottom_fz cur_pointer" :class="{active:query.sortType==2}" @click="changeOrder(2)"></i>
          </span>
        </div>

        <div class="price_ipt">
          <span class="text">价格</span>
          <el-input-number v-model="query.minPrice" @keyup.native="onKeyUp" :controls="false" :min="0" :max="999999" :precision="0" placeholder="￥"></el-input-number>
          <i class="el-icon-minus reduce"></i>
          <el-input-number v-model="query.maxPrice" @keyup.native="onKeyUp" :controls="false" :min="0" :max="9999999" :precision="0" placeholder="￥"></el-input-number>
          <el-button type="info" class="price_btn" @click="surePrice">确定</el-button>
          <p class="clear_btn" @click="query.minPrice=undefined;query.maxPrice=undefined;">清空</p>
        </div>
      </div>
      <div class="table_page" v-if="total">
        <span>{{'共'+total+'件商品'}}</span>
        <span class="totalPage">{{pageInfo.pageNumber+'/'+Math.ceil(total/pageInfo.pageSize)}}</span>
        <el-button class="btn" :disabled='pageInfo.pageNumber==1' icon="el-icon-arrow-left" @click="prevPage"></el-button>
        <el-button class="btn" :disabled='pageInfo.pageNumber==Math.ceil(total/pageInfo.pageSize) || total==0' @click="nextPage">
          <i class="el-icon-arrow-right"></i>
        </el-button>
      </div>
    </div>
    <div v-loading="loading" :style="{minHeight:loading?'600px':''}">
      <!-- 商品列表 -->
      <div class="table_list">
        <div class="list_item" v-for="(item,index) in dataGoodsList" :key="index">
          <div class="img_box">
            <router-link :to="{path:'/goodsDetails/'+item.serNo+'.html'}" target="_blank">
              <img v-lazy="item.mainPreviewImageFilePath" alt="图片加载失败" />
            </router-link>
          </div>
          <div class="sprice" style="padding:6px 10px 0px;">
            市场参考价：
            <span class="line_th">￥{{ item.salePrice | priceValue }}</span>
          </div>
          <div class="price">
            <p class="cprice" v-if="$cookies.isKey('ACCESS_TOKEN')">￥{{item.clientSalePrice | priceValue}}</p>
            <p class="cprice cur_pointer" v-else @click.prevent.stop="$refs.diaLogin.elVisible = true;">登录查看多比价</p>
            <!-- <i class="boutique">{{item.isCanUseForWhole===0?"精品":"拎包"}}</i> -->
          </div>
          <div class="itr">
            <span class="sty_css" v-show="item.styleName">{{item.styleName}}</span>
            <router-link :to="{path:'/goodsDetails/'+item.serNo+'.html'}" target="_blank">
              <span class="com_link">{{item.brandName+" "+item.goodsName+" "+item.mixName}}</span>
            </router-link>
          </div>
          <div class="sale">
            <div class="sale_item" v-if="item.saleCount!=null">
              <img :src="require('@/assets/img/yishousale.png')" alt="">{{item.saleCount+" "}}已售
            </div>
            <div class="sale_item" v-if="item.viewCount!=null">
              <img :src="require('@/assets/img/renqisale.png')" alt="">{{item.viewCount+" "}}人气
            </div>
          </div>
          <div class="add_cart">
            <el-button class="add_item" @click="followGoods(item)">加入收藏</el-button>
            <el-button class="add_item" type="primary" @click="addShoppingCart(item)">加入购物车</el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 没有商品 -->
    <div class="no_goods" v-if="!total">产品正在更新上架，敬请期待。</div>
    <el-pagination class="pagination" v-if="dataGoodsList.length" background @current-change="handleCurrentChange" :current-page="pageInfo.pageNumber" :page-size="pageInfo.pageSize" layout="total, prev, pager, next, jumper" :total="total"></el-pagination>
    <dialog-login ref="diaLogin" @updateLogin="updateLogin"></dialog-login>
    <no-auth ref="noAuth"></no-auth>
  </div>
</template>

<script>
import {
  GetBrandBasicInfo,
  GetBrandGoodsList,
} from "@/pages/page1/api/modules/home";
import {
  AddShopCart,
  AddCollection,
} from "@/pages/page1/api/modules/shoppingCart";
import DialogLogin from "@/pages/page1/components/dialogLogin.vue";
import NoAuth from "@/components/noAuth";
import onlyMessage from "@/pages/publicUtils/resetMessage.js";
export default {
  metaInfo: { title: "品牌汇 - 多比商城" },
  components: {
    DialogLogin,
    NoAuth,
  },
  data() {
    return {
      loading: true,
      brandInfo: {}, //当前品牌信息
      logoFilePathList: [],
      publicizeFilePathList: [],
      // 分类
      categoryList: [],
      cateMore: false,
      cateContentHeight: 48,
      // 属性
      proplist: [],
      showProplist: [], //展示的属性，注意要指针相同
      query: {
        // 获取基本信息的参数
        categorySerNo: "",
        brandSerNos: "",
        // 获取商品列表的参数
        searchKey: "",
        props: {},
        sortType: 0,
        minPrice: undefined,
        maxPrice: undefined,
      },
      pageInfo: {
        pageNumber: 1,
        pageSize: 40,
        searchProperty: [],
        orderProperty: [],
      },
      dataGoodsList: [],
      total: 1,
      seriesList: [],
    };
  },
  mounted() {
    if (this.$store.getters.userTypeA) {
      let query = this.$route.query;
      Object.assign(this.query, query);
      // object类型的需要转换
      this.query.props = query.props ? JSON.parse(query.props) : {};
      // console.log(this.query);
      this.pageInfo.pageNumber = this.$route.query.page || 1;
      this.pageInfo.pageNumber = parseInt(this.pageInfo.pageNumber);
      this.getSearchBasicInfo();
    } else {
      this.$refs.noAuth.open();
    }
  },
  methods: {
    // 初始化
    getSearchBasicInfo() {
      let params = {
        categorySerNo: this.query.categorySerNo,
        brandSerNos: this.query.brandSerNos
          ? this.query.brandSerNos.split(",")
          : [],
      };
      GetBrandBasicInfo(params).then((res) => {
        // console.log("获取分类页属性", res);
        this.brandInfo = res.data[0].brandInfo;
        this.seriesList = res.data[0].seriesList;
        this.logoFilePathList[0] = this.brandInfo.logoFilePath || "";
        this.publicizeFilePathList[0] = this.brandInfo.publicizeFilePath || "";

        this.categoryList = res.data[0].categoryList;
        this.openCateMore();
        this.proplist = this.setPropItem(res.data[0].proplist);
        // 初始化选中属性
        this.proplist.forEach((item) => {
          for (let keyName in this.query.props) {
            if (keyName == item.fieldName) {
              item.showAttr = false;
              item.fieldList.forEach((v) => {
                this.query.props[keyName].forEach((j) => {
                  if (v.value == j) {
                    v.checked = true;
                  }
                });
              });
            }
          }
        });
        // 可展示属性
        this.showProplist = this.proplist.filter((v) => v.showAttr);
        // 更多按钮展示控制
        this.getHeightForMore("cateContentRef", "cateContentHeight", 48);
        this.getPropsHeightForMore();

        this.getGoodsList();
      });
    },
    // 初始化选中的分类被遮挡问题解决
    openCateMore() {
      let i = this.categoryList.findIndex(
        (v) => v.serNo == this.query.categorySerNo
      );
      if (i < 0) return;
      this.$nextTick(() => {
        // console.log(this.$refs["cateItem" + i][0].offsetTop);
        if (this.$refs["cateItem" + i][0].offsetTop > 0) this.cateMore = true;
      });
    },
    setCheckedFalse(arr) {
      arr.forEach((v) => {
        v.checked = false;
      });
      return arr;
    },
    setPropItem(arr) {
      arr.forEach((item) => {
        // 控制属性值数组 更多 多选 显示
        this.$set(item, "fieldList", []);
        this.$set(item, "attrMore", false);
        this.$set(item, "attrMulti", false);
        this.$set(item, "showAttr", true);
        this.$set(item, "attrContentHeight", 48);
        item.fieldValueOption.forEach((v) => {
          item.fieldList.push({
            value: v,
            checked: false,
          });
        });
      });
      return arr;
    },
    getPropsHeightForMore() {
      this.showProplist.forEach((item, index) => {
        this.getHeightForMore(
          "attrContentRef" + index,
          "attrContentHeight",
          48,
          item
        );
      });
    },
    getHeightForMore(ref, typeHeight, height, item) {
      this.$nextTick(() => {
        if (item) {
          let ele = this.$refs[ref][0];
          item[typeHeight] = ele.clientHeight || height;
          // console.log(typeHeight, item[typeHeight]);
          return;
        }
        let ele = this.$refs[ref];
        try {
          this[typeHeight] = ele.clientHeight || height;
        } catch (error) {}
        // console.log(typeHeight, this[typeHeight]);
      });
    },
    getGoodsList() {
      let params = {
        categorySerNo: this.query.categorySerNo,
        brandSerNos: this.query.brandSerNos
          ? this.query.brandSerNos.split(",")
          : [],
        props: this.query.props,
        sortType: this.query.sortType,
        minPrice: this.query.minPrice,
        maxPrice: this.query.maxPrice,
        searchKey: this.query.searchKey,
        pageInfo: this.pageInfo,
      };
      this.loading = true;
      GetBrandGoodsList(params)
        .then((res) => {
          // console.log("获取商品列表", res);
          this.dataGoodsList = res.data;
          this.total = res.count;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.total = 0;
        });
    },

    // 分类 （单击）
    sureCategory(serNo) {
      this.query.categorySerNo = serNo;
      this.query.props = undefined;
      this.reloadSearch();
    },

    // 属性 （单击）
    chooseItem(item, isMulti) {
      // 多选
      if (isMulti) {
        item.checked = !item.checked;
      } else {
        // 单选 若是属性需要关闭其他项的已选未确认
        this.showProplist.forEach((v) => {
          v.fieldList = this.setCheckedFalse(v.fieldList);
        });
        item.checked = true; //再选中
        this.query.props = this.selectPropsObj;
        this.reloadSearch();
      }
    },
    // （打开多选）
    openMulti(item) {
      this.showProplist.forEach((v) => {
        v.fieldList = this.setCheckedFalse(v.fieldList);
        v.attrMulti = false;
        v.attrMore = false;
        if (item && v.fieldName === item.fieldName) {
          v.attrMulti = true;
          v.attrMore = true;
        }
      });
    },
    // （多选确认）
    confirmMulti(arr) {
      let resItem = arr.find((v) => v.checked);
      if (!resItem) {
        onlyMessage.warning("请至少选择一项");
        return;
      }
      this.query.props = this.selectPropsObj;
      this.reloadSearch();
    },
    // （多选取消）
    cancelMulti(arr, item) {
      arr = this.setCheckedFalse(arr);
      item.attrMulti = false;
      item.attrMore = false;
    },

    // 取消select项选中
    cancelSelect(item) {
      // 属性
      this.proplist.forEach((propItem) => {
        propItem.fieldList.forEach((v) => {
          if (item.serNo == v.value) {
            v.checked = false;
          }
        });
      });
      this.query.props = this.selectPropsObj;
      this.reloadSearch();
    },
    // 清空select选中
    clearSelect() {
      this.query.searchKey = undefined;
      this.proplist.forEach((item) => {
        item.fieldList = this.setCheckedFalse(item.fieldList);
      });
      this.query.props = {};
      this.reloadSearch();
    },
    // 排序类别
    changeOrder(num) {
      this.query.sortType = num;
      this.reloadSearch();
    },
    // 价格确认
    surePrice() {
      let actualMinPrice; //实际小的值
      if (this.query.minPrice > this.query.maxPrice) {
        actualMinPrice = this.query.maxPrice;
        this.query.maxPrice = this.query.minPrice;
        this.query.minPrice = actualMinPrice;
      }
      this.reloadSearch();
    },
    onKeyUp(e) {
      // 保留整数值
      let isNum = parseInt(e.target.value);
      // console.log(e.target.value, !/^\d+$/.test(e.target.value), isNum);
      // 如果不是数字
      if (!/^\d+$/.test(e.target.value)) {
        e.target.value = isNum || "";
      }
    },
    // 分页
    handleCurrentChange(val) {
      this.pageInfo.pageNumber = val;
      this.reloadSearch(val);
    },
    prevPage() {
      this.pageInfo.pageNumber = parseInt(this.pageInfo.pageNumber);
      this.pageInfo.pageNumber -= 1;
      this.reloadSearch(this.pageInfo.pageNumber);
    },
    nextPage() {
      this.pageInfo.pageNumber = parseInt(this.pageInfo.pageNumber);
      this.pageInfo.pageNumber += 1;
      this.reloadSearch(this.pageInfo.pageNumber);
    },
    // 页面刷新
    reloadSearch(page) {
      let query = {
        ...this.query,
        page: page ? page : undefined,
      };
      // 优化地址栏参数展示
      for (const key in query) {
        // 分类 关键词优化
        if (query[key] === "") {
          query[key] = undefined;
        }
      }
      query.props = JSON.stringify(query.props);
      if (query.props === "{}") {
        query.props = undefined;
      }
      if (query.sortType === 0) {
        query.sortType = undefined;
      }
      // console.log(query);
      // return
      let newUrl = this.$router.resolve({
        path: "brandCategory",
        query,
      });
      window.open(newUrl.href, "_self");
    },

    // 登录操作
    updateLogin(isLogin) {
      // console.log(isLogin);
      if (isLogin) {
        location.reload();
      }
    },
    addShoppingCart(v) {
      if (this.$cookies.isKey("ACCESS_TOKEN")) {
        let params = {
          goodsMixId: v.id,
          goodsMixCount: 1,
          regionCode: localStorage.getItem("_regionCode"),
        };
        AddShopCart(params).then((res) => {
          // console.log("加入购物车结果", res);
          onlyMessage.success("加入成功");
          this.$store.commit("SET_SHOPCARTNUM");
        });
      } else {
        this.$refs.diaLogin.elVisible = true;
      }
    },
    followGoods(v) {
      if (this.$cookies.isKey("ACCESS_TOKEN")) {
        AddCollection({ goodsMixId: v.id }).then((res) => {
          // console.log("移入收藏", res);
          onlyMessage.success("收藏成功");
        });
      } else {
        this.$refs.diaLogin.elVisible = true;
      }
    },
  },
  computed: {
    selectList() {
      let arr = [];
      // 选中的属性
      this.proplist.forEach((item) => {
        if (!item.attrMulti) {
          item.fieldList.forEach((v) => {
            if (v.checked) {
              arr.push({
                key: item.name,
                value: v.value,
                serNo: v.value,
              });
            }
          });
        }
      });
      return arr;
    },
    // 选中的属性
    selectPropsObj() {
      let obj = {};
      this.proplist.forEach((item) => {
        let haveCheckedArr = item.fieldList.filter((v) => v.checked);
        haveCheckedArr = haveCheckedArr.map((v) => v.value);
        if (haveCheckedArr.length > 0) {
          obj[item.fieldName] = haveCheckedArr;
        }
      });
      // console.log(this.proplist);
      return obj;
    },
  },
};
</script>

<style lang="less" scoped>
.bategory {
  padding-top: 20px;
  padding-bottom: 78px;
  font-size: 12px;
  .brand {
    height: 340px;
    box-sizing: border-box;
    background: #f5f5f5;
    padding: 20px;
    margin-bottom: 20px;
    display: flex;
    line-height: 1;
    overflow: hidden;
    .left {
      width: calc(100% - 600px);
      height: 100%;
      padding: 0 30px 0 10px;
      box-sizing: border-box;
      overflow: hidden;
      .logo {
        display: flex;
        justify-content: center;
        margin-top: 10px;
        .img {
          width: 120px;
          height: 60px;
          background: #ffffff;
          position: relative;
          img {
            width: auto;
            height: auto;
            max-width: 100%;
            max-height: 100%;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
        .name {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          box-sizing: border-box;
          padding: 6px 10px;
          .title {
            font-size: 18px;
            font-weight: bold;
            color: #353535;
          }
          .sale {
            font-size: 14px;
            color: #666666;
          }
        }
      }
      .content {
        margin-top: 20px;
        height: 144px;
        line-height: 24px;
        font-size: 16px;
        color: #666666;
        text-indent: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 6;
        -webkit-box-orient: vertical;
      }
      .dwonload {
        margin-top: 16px;
        line-height: 24px;
        .item {
          margin-right: 20px;
          color: @themeColor;
          cursor: pointer;
          &:hover {
            color: #3190e8 !important;
          }
          &:last-child {
            margin: 0;
          }
        }
      }
    }
    .right {
      width: 600px;
      height: 100%;
    }
  }
  .cate_item {
    border-bottom: dotted 1px #e6e6e6;
    .label {
      width: 90px;
      line-height: 40px;
      padding-left: 20px;
      float: left;

      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .content {
      width: calc(100% - 110px);
      box-sizing: border-box;
      padding: 8px 13px 8px 26px;
      margin-left: 110px;
      color: #333333;
      display: flex;
      .td-list {
        width: 90%;
        box-sizing: border-box;
        padding-right: 60px;
        line-height: 12px;
        .mutl-btn {
          text-align: center;
          margin-top: 10px;
          .btn {
            background-color: #f5f5f5;
            padding: 3px 15px 4px;
            color: #333333;
            border-radius: 2px;
            font-size: 12px;
          }
        }
      }
      .td-more {
        width: 5%;
        text-align: left;
        padding-top: 4px;
      }
      .td-mult {
        width: 5%;
        text-align: right;
        .mult_btn {
          width: 100%;
          height: 22px;
          line-height: 22px;
          border: 1px solid #b6b6b6;
          text-align: center;
          cursor: pointer;
          &:hover {
            color: @themeColor;
            border-color: @themeColor;
          }
        }
      }
    }
  }
  .border2 {
    border: 2px solid #ededed;
  }
  .selected {
    .content {
      color: @themeColor;
      .td-list {
        width: 100%;
        .td_item {
          display: inline-block;
          margin-right: 4px;
          margin-bottom: 6px;
          color: @themeColor;
          height: 16px;
          line-height: 16px;
          padding: 2px 5px 2px 8px;
          border-style: dotted;
          border-width: 1px;
          cursor: pointer;
          &:hover {
            border-style: solid;
          }
          .key_name {
            color: #555;
          }
          .myi {
            color: rgba(255, 0, 0, 1);
            padding-left: 6px;
          }
        }
        .clear {
          border-color: #fff;
          color: #999;
        }
        .keyw {
          cursor: text;
          color: #666;
          font-weight: bold;
          border: 1px solid #fff;
        }
      }
    }
  }
  .classify {
    background-color: #f5f5f7;
    overflow: hidden;
    height: 40px;
    .td-list {
      position: relative;
      .td_item {
        display: inline-block;
        margin-right: 15px;
        margin-bottom: 8px;
        border: none;
        padding: 6px 12px;
        cursor: pointer;

        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
      }
      .active {
        background-color: @themeColor;
        color: #ffffff !important;
      }
    }
  }
  .attr {
    overflow: hidden;
    height: 40px;
    .td-list {
      .td_item {
        display: inline-block;
        padding: 5px 10px;
        margin-right: 15px;
        margin-bottom: 8px;
        cursor: pointer;
        color: #333333;
        border: 1px solid #fff;
      }
      .active {
        border: 1px solid @themeColor;
      }
    }
  }
  .show {
    height: auto;
  }
  .table_header {
    width: 100%;
    height: 40px;
    background: #f5f5f5;
    padding: 0 20px 0 0;
    box-sizing: border-box;
    font-size: 12px;
    margin-top: 18px;
    margin-bottom: 26px;
    color: #666666;
    .table_type {
      display: flex;
      height: 40px;
      line-height: 40px;
      border-left: 1px solid #d9d9d9;
      box-sizing: border-box;
      .header_left {
        width: 80px;
        height: 100%;
        box-sizing: border-box;
        background: #ffffff;
        border: 1px solid #d9d9d9;
        border-left: none;
        text-align: center;
        .price_box {
          display: block;
          width: 60px;
          height: 100%;
          margin: 0 auto;
          text-align: center;
          position: relative;
          text-indent: -8px;
          .top_fz {
            position: absolute;
            top: 6px;
            right: -4px;
            font-size: 16px;
            width: 20px;
            height: 12px;
            line-height: 18px;
            overflow: hidden;
            // background-color: red;
          }
          .bottom_fz {
            position: absolute;
            bottom: 6px;
            right: -4px;
            font-size: 16px;
            width: 20px;
            height: 12px;
            line-height: 6px;
            overflow: hidden;
            // background-color: blue;
          }
        }
        i {
          font-size: 14px;
          font-weight: bold;
          padding-left: 4px;
        }
      }
      .price_ipt {
        margin-left: 32px;
        border: 1px solid #f5f5f5;
        position: relative;
        .text {
          margin-right: 8px;
        }
        /deep/ .el-input-number {
          width: 68px;
          .el-input__inner {
            padding: 0 3px;
            height: 24px;
            background: #ffffff;
            border: 1px solid #eeeeee;
            line-height: 24px;
            text-align: left;
          }
        }
        .reduce {
          margin: 0 4px;
        }
        .price_btn {
          display: none;
          position: absolute;
          bottom: 6px;
          right: 10px;
          background-color: #f5f5f5;
          padding: 3px 15px 4px;
          color: #333333;
          border-radius: 2px;
          font-size: 12px;
        }
        .clear_btn {
          display: none;
          position: absolute;
          bottom: 10px;
          left: 10px;
          line-height: 1;
          color: #005aa0;
          cursor: pointer;
        }
        &:hover {
          padding: 0 10px;
          margin-left: 22px;
          height: 66px;
          border: 1px solid #d9d9d9;
          background-color: #ffffff;
          .price_btn,
          .clear_btn {
            display: block;
          }
        }
      }
      .active {
        color: @themeColor;
      }
    }
    .table_page {
      .totalPage {
        padding: 0 30px;
      }
      .btn {
        width: 46px;
        height: 24px;
        padding: 0px;
        line-height: 22px;
        border-radius: 0px;
      }
    }
  }
  .table_list {
    overflow: hidden; //清除浮动
    .list_item {
      background-color: #ffffff;
      width: calc((100% - 72px) / 4);
      float: left;
      border: 2px solid #f4f4f4;
      padding-top: 10px;
      box-sizing: border-box;
      margin-right: 24px;
      margin-bottom: 30px;
      font-size: 12px;
      transition: box-shadow 0.5s;
      -moz-transition: box-shadow 0.5s; /* Firefox 4 */
      -webkit-transition: box-shadow 0.5s; /* Safari and Chrome */
      -o-transition: box-shadow 0.5s; /* Opera */
      &:hover {
        box-shadow: 0px 6px 5px 0px rgba(4, 0, 0, 0.21);
        margin-bottom: -14px;
        position: relative;
        z-index: 2;
        .add_cart {
          display: block;
        }
      }
      &:nth-child(4n) {
        margin-right: 0;
      }
      .img_box {
        width: 100%;
        height: 256px;
        padding: 0 10px;
        box-sizing: border-box;
      }
      .price {
        font-size: 18px;
        font-weight: bold;
        color: #e52319;
        padding: 0 10px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        .boutique {
          display: block;
          width: 32px;
          height: 18px;
          line-height: 18px;
          text-align: center;
          background: #d8a67d;
          color: #fff;
          font-size: 12px;
          margin-left: 8px;
        }
      }
      .itr {
        padding: 0 10px;
        box-sizing: border-box;
        line-height: 20px;
        height: 40px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        .sty_css {
          display: inline-block;
          line-height: 1;
          background: #631717;
          border-radius: 5px;
          font-size: 12px;
          color: #ffffff;
          font-weight: 500;
          min-width: 60px;
          box-sizing: border-box;
          display: inline-block;
          text-align: center;
          padding: 2px 6px;
          margin-right: 12px;
        }
        a {
          color: #000000;
        }
      }
      .sale {
        display: flex;
        justify-content: space-between;
        border-top: 2px solid #f4f4f4;
        margin-top: 4px;
        line-height: 30px;
        font-size: 12px;
        font-weight: 500;
        color: #631616;
        position: relative;
        .sale_item {
          width: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 12px;
            height: 14px;
            padding-right: 6px;
          }
        }
        &::before {
          position: absolute;
          top: 50%;
          left: 50%;
          content: "";
          width: 1px;
          height: 16px;
          background: #f4f4f4;
          transform: translate(-50%, -50%);
        }
      }
      .add_cart {
        width: 100%;
        height: 44px;
        overflow: hidden;
        box-sizing: border-box;
        padding: 8px 10px 10px;
        font-size: 14px;
        display: none;
        transition: box-shadow 0.5s;
        -moz-transition: box-shadow 0.5s; /* Firefox 4 */
        -webkit-transition: box-shadow 0.5s; /* Safari and Chrome */
        -o-transition: box-shadow 0.5s; /* Opera */
        .add_item {
          width: 50%;
          height: 26px;
          padding: 0;
          border-radius: 0;
          float: left;
          &:first-child {
            margin-left: 0;
            border: 1px solid #f4f4f4;
            color: @themeColor;
          }
          &:last-child {
            margin-left: 0;
          }
        }
      }
    }
  }
  .no_goods {
    height: 200px;
    line-height: 200px;
    font-size: 14px;
    font-weight: 700;
    background-color: #fffdee;
    border: 1px solid #edd28b;
    text-align: center;
  }
  .pagination {
    text-align: right;
    margin-top: 30px;
  }
  /deep/ .el-loading-spinner {
    top: 200px;
  }
}
</style>